var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-gray"},[(_vm.hasExtuinInfo)?_c('gray-card',{attrs:{"processedText":_vm.processedText,"text":_vm.text,"uin-info":_vm.uinInfo}}):_c('span',{class:_vm.device,domProps:{"innerHTML":_vm._s(_vm.processedText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }